import { render } from "./CoverArtistItem.vue?vue&type=template&id=1621c7d8"
import script from "./CoverArtistItem.vue?vue&type=script&lang=js"
export * from "./CoverArtistItem.vue?vue&type=script&lang=js"

import "./CoverArtistItem.vue?vue&type=style&index=0&id=1621c7d8&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__